import React, { useRef, useEffect } from 'react';

import { Element } from 'Component/others';
import { useTooltip } from 'Store/tooltip';
import { Box } from '@chakra-ui/react';

const Tooltip = ({ children, label, align = 'center', width = 'unset', placement = 'center', htmlComponent, className }) => {
  const onOpenTooltip = useTooltip((state) => state.onOpenTooltip);
  const onCloseTooltip = useTooltip((state) => state.onCloseTooltip);
  const ref = useRef(null);
  const isEmpty = (!label || label === '-') && !htmlComponent;

  const onMouseEnter = () => {
    const rect = ref?.current?.getBoundingClientRect();

    const x = rect?.x ?? 0;
    const y = rect?.y + rect?.height + 8 ?? 0;
    const childrenWidth = rect?.width;

    !isEmpty && onOpenTooltip({ label, position: { x, y }, childrenWidth, align, width, placement, htmlComponent });
  };

  const onMouseLeave = () => {
    onCloseTooltip();
  };

  const onClick = () => {
    onCloseTooltip();
  };

  useEffect(() => {
    return () => {
      onCloseTooltip();
    };
  }, [onCloseTooltip]);

  return (
    <Box onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} ref={ref} onClick={onClick} className={className}>
      <Element value={children} />
    </Box>
  );
};

export default Tooltip;
